export default {
    es: {
        company: {
            tabs: {
                myCompany: "Mi Empresa",
                manageUsers: "Gestionar Usuarios",
                allCompanies: "Todas las Empresas"
            },
            details: {
                title: "Detalles de la Empresa",
                companyName: "Nombre de la Empresa",
                taxId: "NIT / ID Fiscal",
                country: "País",
                city: "Ciudad",
                address: "Dirección",
                numberOfEmployees: "Número de Empleados",
                salesValue: "Valor de Ventas",
                ciiuCode: "Código CIIU"
            },
            actions: {
                leaveCompany: "Abandonar Empresa",
                edit: "Editar",
                cancel: "Cancelar",
                save: "Guardar",
                createCompany: "Crear Empresa"
            },
            noCompany: {
                message: "Aún no tienes una empresa",
                create: "Crear Empresa"
            },
            invite: {
                title: "Invitar Usuario",
                emailLabel: "Correo del Usuario",
                sendButton: "Enviar Invitación"
            },
            members: {
                title: "Miembros de la Empresa",
                noMembers: "No se encontraron miembros",
                you: "Tú",
                admin: "Admin",
                tooltipRevoke: "Quitar Admin",
                tooltipMakeAdmin: "Hacer Admin",
                tooltipRemove: "Eliminar Usuario",
                confirmRemove: "¿Eliminar {email} de la empresa?",
                confirmLeave: "¿Estás seguro de que deseas abandonar esta empresa?"
            },
            invitations: {
                title: "Invitaciones Pendientes",
                noPending: "No hay invitaciones pendientes",
                sent: "Enviado:"
            },
            allCompanies: {
                createButton: "Crear Empresa"
            },
            columns: {
                name: "Nombre",
                taxId: "NIT",
                country: "País",
                city: "Ciudad",
                employees: "Empleados",
                actions: "Acciones"
            },
            createDialog: {
                title: "Crear Nueva Empresa",
                companyName: "Nombre de la Empresa *",
                taxId: "NIT / ID Fiscal",
                country: "País",
                city: "Ciudad",
                cancel: "Cancelar",
                create: "Crear"
            },
            createUser: {
                title: "Crear Usuario en la Empresa",
                username: "Nombre de usuario *",
                password: "Contraseña *",
                email: "Correo electrónico",
                firstName: "Nombre",
                lastName: "Apellido",
                makeAdmin: "Hacer administrador de empresa",
                createButton: "Crear Usuario",
                errorRequired: "El {field} es obligatorio"
            },
            editUser: {
                tooltip: "Editar usuario",
                title: "Editar Usuario",
                newPassword: "Nueva contraseña",
                passwordHint: "Dejar en blanco para no cambiarla"
            },
            notifications: {
                companySaved: "Empresa actualizada exitosamente",
                companySaveError: "No se pudo actualizar la empresa",
                companyCreated: "Empresa creada exitosamente",
                companyCreatedError: "No se pudo crear la empresa",
                companyDeleted: "Empresa eliminada exitosamente",
                companyDeletedError: "No se pudo eliminar la empresa",
                userCreated: "Usuario creado exitosamente",
                userCreatedError: "No se pudo crear el usuario",
                userUpdated: "Usuario actualizado exitosamente",
                userUpdatedError: "No se pudo actualizar el usuario",
                userRemoved: "Usuario eliminado de la empresa",
                userRemovedError: "No se pudo eliminar el usuario",
                adminUpdated: "Permisos de administrador actualizados",
                adminUpdatedError: "No se pudo actualizar el estado de administrador",
                invitationSent: "Invitación enviada exitosamente",
                invitationSentError: "No se pudo enviar la invitación",
                invitationCancelled: "Invitación cancelada",
                invitationCancelledError: "No se pudo cancelar la invitación",
                leftCompany: "Has abandonado la empresa",
                leaveCompanyError: "No se pudo abandonar la empresa"
            }
        },
    },
    en: {
        company: {
            tabs: {
                myCompany: "My Company",
                manageUsers: "Manage Users",
                allCompanies: "All Companies"
            },
            details: {
                title: "Company Details",
                companyName: "Company Name",
                taxId: "Tax ID",
                country: "Country",
                city: "City",
                address: "Address",
                numberOfEmployees: "Number of Employees",
                salesValue: "Sales Value",
                ciiuCode: "CIIU Code"
            },
            actions: {
                leaveCompany: "Leave Company",
                edit: "Edit",
                cancel: "Cancel",
                save: "Save",
                createCompany: "Create Company"
            },
            noCompany: {
                message: "You don't have a company yet",
                create: "Create Company"
            },
            invite: {
                title: "Invite User",
                emailLabel: "User Email",
                sendButton: "Send Invitation"
            },
            members: {
                title: "Company Members",
                noMembers: "No members found",
                you: "You",
                admin: "Admin",
                tooltipRevoke: "Revoke Admin",
                tooltipMakeAdmin: "Make Admin",
                tooltipRemove: "Remove User",
                confirmRemove: "Remove {email} from company?",
                confirmLeave: "Are you sure you want to leave this company?"
            },
            invitations: {
                title: "Pending Invitations",
                noPending: "No pending invitations",
                sent: "Sent:"
            },
            allCompanies: {
                createButton: "Create Company"
            },
            columns: {
                name: "Name",
                taxId: "Tax ID",
                country: "Country",
                city: "City",
                employees: "Employees",
                actions: "Actions"
            },
            createDialog: {
                title: "Create New Company",
                companyName: "Company Name *",
                taxId: "Tax ID",
                country: "Country",
                city: "City",
                cancel: "Cancel",
                create: "Create"
            },
            createUser: {
                title: "Create User in Company",
                username: "Username *",
                password: "Password *",
                email: "Email",
                firstName: "First Name",
                lastName: "Last Name",
                makeAdmin: "Make company admin",
                createButton: "Create User",
                errorRequired: "{field} is required"
            },
            editUser: {
                tooltip: "Edit user",
                title: "Edit User",
                newPassword: "New password",
                passwordHint: "Leave blank to keep the current password"
            },
            notifications: {
                companySaved: "Company updated successfully",
                companySaveError: "Failed to update company",
                companyCreated: "Company created successfully",
                companyCreatedError: "Failed to create company",
                companyDeleted: "Company deleted successfully",
                companyDeletedError: "Failed to delete company",
                userCreated: "User created successfully",
                userCreatedError: "Failed to create user",
                userUpdated: "User updated successfully",
                userUpdatedError: "Failed to update user",
                userRemoved: "User removed from company",
                userRemovedError: "Failed to remove user",
                adminUpdated: "Admin permissions updated",
                adminUpdatedError: "Failed to update admin status",
                invitationSent: "Invitation sent successfully",
                invitationSentError: "Failed to send invitation",
                invitationCancelled: "Invitation cancelled",
                invitationCancelledError: "Failed to cancel invitation",
                leftCompany: "You have left the company",
                leaveCompanyError: "Failed to leave company"
            }
        },
    },
}
